import { NAV_BAR } from '../actions/NavBarActions'

export default function navBarReducer(state = null, action) {
  switch (action.type) {
    case NAV_BAR:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
